export default __webpack_public_path__ + "static/media/1 - Благоустройство парков.60519f02.jpg";